import { Component, Input, Output, AfterContentInit, ViewChild, forwardRef, ElementRef, EventEmitter  } from '@angular/core';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ClientsService } from '../_services/generatedServices';
import { AuthenticationService } from '../_services/authentication.service';
import { ClientSummaryDTO } from '../_models/generatedModels';
import { dynamicSort } from '../_helpers/extensions.module';


@Component({
    selector: 'runners-dropdown',
    host: {
        '[class.rundnaDropdown]': 'someAttr',
    },
    template: `
    <kendo-combobox #combo [data]="comboData" [disabled]="isDisabled" [valuePrimitive]="true" [filterable]="true" [popupSettings]="{popupClass: 'df-list-scroller'}" valueField="userId" textField="userFullName" [(ngModel)]="selectedValue" class="{{cssClass}}" (filterChange)="handleFilter($event)" (valueChange)="onChange($event)"></kendo-combobox>
  `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RunnerDropdownControl),
            multi: true
        }
    ]
})

export class RunnerDropdownControl implements ControlValueAccessor, AfterContentInit {

    someAttr: string = 'anyValue';

    constructor(elementRef: ElementRef, private clientData: ClientsService, private auth: AuthenticationService) {
        this.cssClass = elementRef.nativeElement.getAttribute('class');
        elementRef.nativeElement.setAttribute('class', '');
    }

    @Input()
    selectedValue: string = '';

    @Input()
    isDisabled: boolean;

    @Output()
    changed = new EventEmitter<string>();

    comboData: ClientSummaryDTO[] = [];
    runners: ClientSummaryDTO[] = [];
    @ViewChild('combo') public combo: ComboBoxComponent | undefined;
    cssClass: string = '';


    propagateChange = (_: any) => { };
    propagateTouch = () => { };

    writeValue(value: string): void {
        this.selectedValue = value;
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.propagateTouch = fn;
    }

    onChange(value: any) {
        this.writeValue(value);
        this.propagateChange(this.selectedValue);
        this.propagateTouch();
        this.changed.emit(value);
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    ngAfterContentInit(): void {
      this.auth.fetchUserProfile().subscribe((user) => {
        this.clientData.getActiveClientsForUser(user.id).subscribe(results => {
          this.runners = results.sort(dynamicSort('userFullName'));
          this.comboData = results.sort(dynamicSort('userFullName'));

        });
      });
  }

    handleFilter(value: any) {
      if (value.length >= 1) {
          this.comboData = this.runners.filter(x => x.userFullName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
      } else {
          this.comboData = this.runners;
          this.combo.toggle(false);
      }
  }
}
